export default __webpack_public_path__ + "img/pin_icons/medgas_outlet_w.svg";